import { FormField } from "@/overlay/components/form-field";
import { t } from "@lingui/core/macro";
import { Aggregate } from "@mm/api.meteomatics.com";
import type { DropdownItem } from "@mm/zeus";

function AggregateSelect({
  activeId,
  change,
}: { activeId: Aggregate[]; change: (selectedItems: DropdownItem[]) => void }) {
  const aggregateItems: DropdownItem[] = Object.values(Aggregate).map((aggregate, index) => ({
    id: aggregate,
    title: aggregate,
  }));
  return (
    <FormField label={t`Aggregate`}>
      <select
        data-testid={"aggregate-select"}
        value={activeId[0]}
        onChange={(event) => {
          const item = aggregateItems.find((agg) => agg.id === event.target.value);
          if (item) {
            change([item]);
          }
        }}
      >
        {aggregateItems.map((aggregateItem: DropdownItem) => {
          return (
            <option key={aggregateItem.id} value={aggregateItem.id}>
              {aggregateItem.title}
            </option>
          );
        })}
      </select>
    </FormField>
  );
}

export default AggregateSelect;
